/*
NAME: Monitoring
DESC: Componente será responsável pela renderização do mapa de equipamentos e a lista de trabalhos
props:
- 
- - - - Default
- style: Object, style object to overwrite this component style

NOTES:
    - #TODO - Mapa não mostra a posição dos equipamentos dos trabalhos listados
    
*/

import React, { useEffect, useState } from 'react';
import BasicCard from "../basic/BasicCard";
import InfoCard from "../basic/InfoCard";
import RowContainer from "../basic/RowContainer";
import RowContainerItem from "../basic/RowContainerItem";
import EquipmentsMap from "../specific/EquipmentsMap";
import WorksGetData from '../../usecases/WorksGetData';
import MonitorList from '../specific/MonitorList';
import strings from '../../values/strings/strings'
import MonitoringItem from './MonitoringItem';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import values from '../../values/values';
import { Divider } from '@mui/material';
import Refresh from '../basic/Refresh';
import WorksGetMonitoring from '../../usecases/WorksGetMonitoring';

function Monitoring({ }) {

  const [trabalhos, settrabalhos] = useState([])
  const [loading, setloading] = useState(null)
  const [usuarioLogado, setusuarioLogado] = useState(null)
  const [equipamentosConectados, setequipamentosConectados] = useState(0)
  const [areaMapeada, setareaMapeada] = useState(0)
  const [precisao, setprecisao] = useState([])
  const [itemSelecionado, setItemSelecionado] = useState(null)
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let id = window.location.pathname.split('/')[2]

    if (id) setItemSelecionado({ id: id })

    if (!id) {
      setItemSelecionado(null)
      getWorks()
    }

  }, [])

  useEffect(() => {

    if (trabalhos.length > 0) {
      let copia = [...trabalhos]
      calculoPrecisao(copia)
      //-----------------------------------      
      let total = 0
      trabalhos.forEach(item => {
        let count
        if (item.equipamento.connected) {
          count++
        } else {
          count--
        }

        if (item.plantio.plantio_ponto && item.pulv.pulv_ponto) {
          let totalPulv = 0
          let totalPlantio = 0


          if (item.plantio.plantio_ponto && item.pulv.pulv_ponto) {
            let totalPulv = 0
            let totalPlantio = 0

            totalPulv = (item.pulv.pulv_ponto.vazao_geral_lha * 100)
            totalPulv = totalPulv / item.pulv.config_taxa_alvo

            totalPlantio = (item.plantio.plantio_ponto.sementes_metro_total * 100)
            totalPlantio = totalPlantio / item.plantio.config_sementesmetro

            total = total + ((totalPulv + totalPlantio) / 2)
          }

          if (item.plantio.plantio_ponto && !item.pulv.pulv_ponto) {
            let totalPlantio = 0
            totalPlantio = (item.plantio.plantio_ponto.sementes_metro_total * 100)
            totalPlantio = totalPlantio / item.plantio.config_sementesmetro

            total = total + totalPlantio
          }

          if (!item.plantio && item.pulv) {
            let totalPulv = 0
            totalPulv = (item.pulv.pulv_ponto.vazao_geral_lha * 100)
            totalPulv = totalPulv / item.pulv.config_taxa_alvo
            total = total + totalPulv
          }

          if (!item.plantio && !item.pulv) {
            total = total + 0
          }
        }
      })

      total = total / trabalhos.length
      setprecisao(total.toFixed(0))

      
      
      //area mapeada
      let area = 0
      trabalhos.forEach(function (item, index) {
        if (!trabalhos[index]) return ' - - '

        if (trabalhos[index].plantio) {
          try {
            area += trabalhos[index].plantio.plantio_ponto.areaplantada_ha
          } catch (e) {
            return ' - - '
          }
        } else if (trabalhos[index].pulv) {
          try {
            area += trabalhos[index].pulv.pulv_ponto.area_pulverizada //#TODO - NÃO USAR METROS PERCORRIDOS, AREA
          } catch (e) {
            return ' - - '
          }
        } else if (trabalhos[index].plantio && trabalhos[index].pulv) {
          area += trabalhos[index].plantio.plantio_ponto.areaplantada_ha + trabalhos[index].pulv.pulv_ponto.area_pulverizada
        }
        
        else {
          return ' - - '
        }

      })
   
      setareaMapeada(area.toFixed(2))
    }
  }, [trabalhos])
  
  const calculoPrecisao = (item) => {
    // WorksGetPrecision(item) #TODO - Item de plantio ponto consta como undeined

  }

  const getWorks = () => {
    setloading(true)
    WorksGetMonitoring(null, null, true).then(data => {
      settrabalhos(Array.isArray(data) ? data : [])
    }).catch(err => {
      console.error('Erro ao buscar trabalhos em monitoramento:', err)
      settrabalhos([])
    }).finally(() => {
      setloading(false)
    })
  }

  const itemSelected = (id) => {
    setItemSelecionado({ id: id })
  }

  const atualizar = () => {
    history.push('/dashboard')
  }

  const onDelete = (deletedId) => {
    settrabalhos(prevTrabalhos => {
      const deletedIndex = prevTrabalhos.findIndex(work => work.id === deletedId)
      if (deletedIndex === -1) {
        return prevTrabalhos
      };
      const copia = [...prevTrabalhos]
      copia.splice(deletedIndex, 1)
      return copia
    })
  }

  return (
    <div style={{ width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box' }}>
      {!itemSelecionado &&
        <div style={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
          <RowContainer>
            <RowContainerItem style={{ display: 'flex', flex: 4, flexDirection: 'column', width: '100%', minWidth: 0 }}>
              <div style={{ width: '100%', minHeight: 280, height: 'auto' }}>
              <EquipmentsMap trabalhos={trabalhos} height={300} />
              </div>
            </RowContainerItem>
            <RowContainerItem style={{display:'flex', flex: 1, flexDirection: 'column', width: '100%', minWidth: 0}} >
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
              <InfoCard style={{height:150}} title={<span style={{ fontSize: 25 }}>{strings.getString('unity_area_map')}</span>} value={areaMapeada + ' ha'} />
              <Divider orientation="horizontal" flexItem style={{ margin: values.margin[1], width: '100%' }} />
              <InfoCard style={{height:150}} title={<span style={{ fontSize: 25 }}>{strings.getString('equips_connecteds')}</span>} value={equipamentosConectados} />
            </div>
            </RowContainerItem>
          </RowContainer>  
          <Divider orientation="horizontal" flexItem style={{ margin: values.margin[1], width: '100%', maxWidth: '100%' }} />
          <RowContainer>
            <RowContainerItem>
              <BasicCard >
                <MonitorList
                  onSelect={itemSelected}
                  usuarioLogado={usuarioLogado}
                  RowsPerPage={10} 
                  items={trabalhos}
                  refresh={getWorks}
                  loading={loading}
                  onDelete={onDelete}
                />
                <Refresh onClick={getWorks} />
              </BasicCard>
            </RowContainerItem>
          </RowContainer>
        </div>
      }
      {itemSelecionado &&
        <MonitoringItem item={itemSelecionado} setItemSelecionado={setItemSelecionado} />
      }
    </div>
  );
}

export default Monitoring;
